import { StepId, Steps } from "./StepDefinitions";
import { firstStep, getNextStep, getPrevStep } from "@/domains/quiz/StepUtils";
import { validateStep } from "./StepValidation";
import { DogForm } from "@/domains/dog/DogFormSchema";

type StepForm = Partial<DogForm>;

export class DogStepState {
  constructor(private readonly perDogStep: Record<string, StepId>) {}

  getStep(dogId: string): StepId {
    return this.perDogStep[dogId] || firstStep();
  }

  canContinue(dogId: string, form: StepForm) {
    const step = this.getStep(dogId);
    const validation = validateStep(step, form);
    return validation.valid;
  }

  next(dogId: string, form: StepForm) {
    const current = this.getStep(dogId);

    const validation = validateStep(current, form);
    if (!validation.valid) {
      return { error: validation.message };
    }

    const nextStep = getNextStep(current);
    if (!nextStep) return { done: true };

    this.perDogStep[dogId] = nextStep;
    return { step: nextStep };
  }

  prev(dogId: string) {
    const current = this.getStep(dogId);
    const prev = getPrevStep(current);
    if (!prev) return { atStart: true };
    this.perDogStep[dogId] = prev;
    return { step: prev };
  }
}
